import React, { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import T2CPhoto from '../../../assets/images/t2c-photo.png'
import { PartnersTypes } from '../../../enums/enums'
import QuestionBlock from '../../../components/QuestionBlock'

const why = [
  {
    title: 't2c-page.infoBlock.whyCard.question1.title',
    description: 't2c-page.infoBlock.whyCard.question1.description',
  },
  {
    title: 't2c-page.infoBlock.whyCard.question2.title',
    description: 't2c-page.infoBlock.whyCard.question2.description',
  },
  {
    title: 't2c-page.infoBlock.whyCard.question3.title',
    description: 't2c-page.infoBlock.whyCard.question3.description',
  },
  {
    title: 't2c-page.infoBlock.whyCard.question4.title',
    description: 't2c-page.infoBlock.whyCard.question4.description',
  },
]

export const how = [
  {
    description: 't2c-page.infoBlock.howCard.description1',
  },
  {
    description: 't2c-page.infoBlock.howCard.description2',
  },
  {
    description: 't2c-page.infoBlock.howCard.description3',
  },
  // {
  //     description: 't2c-page.infoBlock.howCard.description4',
  // }
]

const questions = [
  {
    title: 't2c-page.infoBlock.questionsCard.question1.title',
    description: 't2c-page.infoBlock.questionsCard.question1.description',
  },
  {
    title: 't2c-page.infoBlock.questionsCard.question2.title',
    description: 't2c-page.infoBlock.questionsCard.question2.description',
  },
  {
    title: 't2c-page.infoBlock.questionsCard.question3.title',
    description: 't2c-page.infoBlock.questionsCard.question3.description',
  },
  {
    title: 't2c-page.infoBlock.questionsCard.question4.title',
    description: 't2c-page.infoBlock.questionsCard.question4.description',
  },
  {
    title: 't2c-page.infoBlock.questionsCard.question5.title',
    description: 't2c-page.infoBlock.questionsCard.question5.description',
  },
  {
    title: 't2c-page.infoBlock.questionsCard.question6.title',
    description: 't2c-page.infoBlock.questionsCard.question6.description',
  },
]

interface WhyCardProps {
  index: number
  title: string
  description: string
}

const WhyCard: FC<WhyCardProps> = ({ index, title, description }) => {
  return (
    <div className=' flex-1 md:w-1/4 w-full relative'>
      <div className='w-full absolute top-0 left-0 right-0 flex justify-center'>
        <div className='font-nexaBold text-2xl bg-secondary rounded-full h-[50px] flex items-center justify-center w-[50px] border-[4px] border-white'>
          {index}
        </div>
      </div>
      <div className='mt-8' />
      <div className='text-base mt-8 items-center h-5/6 mx-4 bg-lightCyan md:px-4 px-8'>
        <div className='font-nexaBold text-xl text-center pt-12'>{title}</div>
        <div className='py-8 text-center align-text-center pb-12'>{description}</div>
      </div>
    </div>
  )
}
const HowLine = ({ description }: { description: string }) => {
  return (
    <div className='flex flex-row w-full items-center py-4' key={description}>
      <div className='pr-4'>
        <svg
          width='36'
          height='37'
          viewBox='0 0 36 37'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect y='0.5' width='36' height='36' rx='18' fill='#40C1AC' />
          <path
            d='M26 12.5L15 23.5L10 18.5'
            stroke='white'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </div>
      <div className='flex items-start justify-start'>
        <div>{description}</div>
      </div>
    </div>
  )
}

const InfoBlock: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className='w-full flex flex-col items-center justify-center'>
      <div className='w-full flex flex-col bg-white py-12 items-center justify-center'>
        <div className='font-nexaBold text-2xl text-center mb-4'>
          {t('t2c-page.infoBlock.whyCard.title')}
        </div>
        <div className='w-full flex flex-row md:flex-row flex-col flex justify-between container mx-auto'>
          {why.map((item, index) => (
            <WhyCard
              key={`why-${index + 1}-${item?.title}`}
              index={index + 1}
              title={t(item.title)}
              description={t(item.description)}
            />
          ))}
        </div>
      </div>
      <div className='w-full flex flex-col bg-[#D9F3EE] py-12 items-center justify-center'>
        <div className='w-full flex md:flex-row flex-col items-center justify-between container mx-auto px-4'>
          <div className='md:w-7/12 w-full md:pb-0 pb-4 flex items-center justify-center'>
            <img src={T2CPhoto} alt='why' />
          </div>
          <div className='md:w-5/12 w-full flex flex-col items-center justify-center px-4'>
            <div className='font-nexaBold text-2xl text-center mb-4'>
              {t('t2c-page.infoBlock.howCard.title')}
            </div>
            <div className='w-full'>
              {how.map((item, index) => (
                <HowLine
                  description={t(item.description)}
                  key={`${index + 1}-card-${item?.description}`}
                />
              ))}
            </div>
            <div />
          </div>
        </div>
      </div>
      <div className='w-full flex flex-col bg-white py-12 items-center justify-center'>
        <div className='font-nexaBold text-2xl text-center mb-4 mt-10'>
          {t('t2c-page.infoBlock.partners.title')}
        </div>
        <div className='w-full flex flex-wrap sm:flex-row flex-col container justify-start px-4 gap-[1%]'>
          {PartnersTypes.map((item, index) => (
            <div
              key={`${index + 1}-cardParteneres-${item?.name}`}
              className=' flex flex-col items-center bg-infoBackground justify-between sm:min-w-[24%] sm:max-w-[24%] min-h-[234px] min-w-[50%] w-full flex-1 md:w-[24%] w-full py-10 my-4'
            >
              <div />
              {item.icon && (
                <div className='w-full flex items-center justify-center'>
                  <img src={item?.icon} alt={item.name} className='w-6/12' />
                </div>
              )}
              <div className='font-nexaRegular text-xl text-center mt-8 '> {item.name}</div>
              {!item.icon && <div />}
            </div>
          ))}
        </div>
      </div>
      <div className='w-full flex flex-col bg-white py-12 justify-center items-center'>
        <div className='w-full flex flex-col container px-4'>
          <h1 className='text-[36px] font-bold mb-[28px] text-left'>
            {t('t2c-page.infoBlock.questionsCard.title')}
          </h1>
          {QuestionBlock(questions)}
        </div>
      </div>
    </div>
  )
}

export default InfoBlock
